import { getterTree } from "typed-vuex";
import state from "./state";

/**
 * Admin module getters.
 */
const getters = getterTree(state, {});

export default getters;
